import { render } from "./IntegracaoInternaAusencia.vue?vue&type=template&id=73795a00"
import script from "./IntegracaoInternaAusencia.vue?vue&type=script&lang=js"
export * from "./IntegracaoInternaAusencia.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__